module.exports = __webpack_public_path__ + "static/img/6333_phase_function_Paper_Points.ce630ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6333_phase_function_Paper_Points.png
// module id = lpXY
// module chunks = 0